import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import GoogleCatalogMgr from './components/GoogleCatalogMgr';

export default function GoogleCatalogIndexPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Google Catalog Manager</h3>
        </Col>
      </Row>
      <Row>
        <GoogleCatalogMgr />
      </Row>
    </Container>
  );
}
